import { State } from 'interfaces/state'

export const settingsSelector = (state: State) => state.app.settings
